<template>
<v-content class="skills-tab">
  <v-list subheader three-line>
    <v-subheader class="overline float-right">Software</v-subheader>
    <v-list-item v-for="software in softwares" :key="software.id">
      <v-list-item-content>
        <v-list-item-title v-text="software.name"></v-list-item-title>
        <v-list-item-subtitle v-text="software.description"></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-divider></v-divider>
  <v-list subheader three-line>
    <v-subheader class="overline float-right">Soft skills</v-subheader>
    <v-list-item v-for="skill in softSkills" :key="skill.id">
      <v-list-item-content>
        <v-list-item-title v-text="skill.name"></v-list-item-title>
        <v-list-item-subtitle v-text="skill.explanation"></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-divider></v-divider>
  <v-list subheader three-line>
    <v-subheader class="overline float-right">Spoken languages</v-subheader>
    <v-list-item v-for="language in spokenLanguages" :key="language.id">
      <v-list-item-content>
        <v-list-item-title v-text="language.name"></v-list-item-title>
        <v-list-item-subtitle v-text="language.level"></v-list-item-subtitle>
        <v-list-item-subtitle v-if="language.certificate != null" v-text="'Certificate: ' + language.certificate"></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-divider></v-divider>
</v-content>
</template>

<script>
export default {
  name: 'SkillsTab',
  props: {
    softwares: Array,
    softSkills: Array,
    spokenLanguages: Array
  },
  data() {

    return {
      // items: [{
      //     action: 'local_activity',
      //     title: 'Attractions',
      //     items: [{
      //       title: 'List Item'
      //     }, ],
      //   },
      //   {
      //     action: 'restaurant',
      //     title: 'Dining',
      //     active: true,
      //     items: [{
      //         title: 'Breakfast & brunch'
      //       },
      //       {
      //         title: 'New American'
      //       },
      //       {
      //         title: 'Sushi'
      //       },
      //     ],
      //   },
      //   {
      //     action: 'school',
      //     title: 'Education',
      //     items: [{
      //       title: 'List Item'
      //     }, ],
      //   },
      //   {
      //     action: 'directions_run',
      //     title: 'Family',
      //     items: [{
      //       title: 'List Item'
      //     }, ],
      //   },
      //   {
      //     action: 'healing',
      //     title: 'Health',
      //     items: [{
      //       title: 'List Item'
      //     }, ],
      //   },
      //   {
      //     action: 'content_cut',
      //     title: 'Office',
      //     items: [{
      //       title: 'List Item'
      //     }, ],
      //   },
      //   {
      //     action: 'local_offer',
      //     title: 'Promotions',
      //     items: [{
      //       title: 'List Item'
      //     }, ],
      //   },
      // ],
    }
  }
}
</script>
